module.exports = __webpack_public_path__ + "static/media/products_services3.0cf2f09f.jpg";